import { RouterState } from 'connected-react-router';

import { AnalyticsParams } from '@hh.ru/analytics-js/lib/hhAnalytics';
import { Breakpoint as MagritteBreakpoint } from '@hh.ru/magritte-ui';
import { autoGeneratedReducer, ReducerObject } from '@hh.ru/redux-create-reducer';

import {
    RequestData,
    TrlState,
    ExperimentsState,
    PageErrorState,
    Locale,
    Platform,
    SiteLanguages,
    DisplayType,
    FetchDataErrorType,
} from '../../types';

enum BlokoBreakpoint {
    XS = 'xs',
    S = 's',
    M = 'm',
    L = 'l',
}

const reducer = {
    trl: autoGeneratedReducer<TrlState>({}),
    langs: autoGeneratedReducer<SiteLanguages[]>([SiteLanguages.RU]),
    features: autoGeneratedReducer<Record<string, unknown>>({}),
    experiments: autoGeneratedReducer<ExperimentsState>({
        checked: [],
        enabled: {},
    }),
    pageError: autoGeneratedReducer<PageErrorState | null>(null),
    request: autoGeneratedReducer<RequestData>({
        pageName: '',
        protocol: 'https',
        host: 'hh.ru',
        url: '',
        id: '',
        xsrfToken: '',
    }),
    isProxiedComponent: autoGeneratedReducer<boolean>(false),
    config: autoGeneratedReducer<{ hhcdnHost: string; staticHost: string; imageResizingCdnHost: string }>({
        hhcdnHost: '',
        staticHost: '',
        imageResizingCdnHost: '',
    }),
    analyticsParams: autoGeneratedReducer<AnalyticsParams>({
        hhtmFrom: '',
        hhtmSource: '',
        hhtmFromLabel: '',
        hhtmSourceLabel: '',
    }),
    fetchingData: autoGeneratedReducer<boolean>(false),
    fetchDataError: autoGeneratedReducer<FetchDataErrorType>(null),
    SPAError: autoGeneratedReducer<'network' | 'default' | null>(null),
    isWebView: autoGeneratedReducer<boolean>(false),
    hasDestroyIfAppRouteNotExist: autoGeneratedReducer<boolean>(true),
    locale: autoGeneratedReducer<Locale>({
        areaId: '',
        domainAreaId: '',
        host: '',
        protocolHost: '',
        isSeoDomain: false,
        platform: Platform.HeadHunter,
        availableLanguages: [SiteLanguages.RU],
        siteLanguage: SiteLanguages.RU,
    }),
    displayType: autoGeneratedReducer<DisplayType>(null),
    backUrl: autoGeneratedReducer<string>('/'),
    disabledReduxSpaMiddlware: autoGeneratedReducer(false),
    renderRestriction: autoGeneratedReducer<{
        breakpoint?: BlokoBreakpoint;
        force: boolean;
        magritteBreakpoint?: MagritteBreakpoint;
        renderRestriction: false;
    }>({
        force: false,
        renderRestriction: false,
    }),
};

export default reducer;

type Store<R = typeof reducer> = { [K in keyof R]: R[K] extends ReducerObject<infer D, unknown> ? D : never };

export interface BaseRootState extends Store {
    router: RouterState;
}

declare module 'react-redux' {
    /* Нужно только для NonNullableRootState хука useSelectorNonNullable */

    // eslint-disable-next-line @typescript-eslint/no-empty-object-type
    export interface DefaultRootState extends BaseRootState {}
}

declare module 'redux' {
    export interface Dispatch<A extends Action = AnyAction> {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/prefer-function-type
        (batchedAction: A[]): any;
    }
}
